var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouseExchangeSecond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "house-exchange-percent") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2-Request---before-approve-++",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.5-Requests_Request_LM-forecast",
    transform: "translate(-934.000000, -675.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "house-exchange-percent",
    transform: "translate(933.000000, 674.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#181818",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "5.41666667 2.08333333 6.66666667 3.33333333 5.41666667 4.58333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66666667,3.33333333 L4.99968333,3.33333333 C3.61914826,3.33333333 2.5,4.45248159 2.5,5.83301667 L2.5,5.83333333",
    id: "Path",
    stroke: "#181818",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#181818",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "14.5833333 18.75 13.3333333 17.5 14.5833333 16.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333333,17.5 L15.0003167,17.5 C16.3808517,17.5 17.5,16.3808517 17.5,15.0003167 L17.5,15",
    id: "Path",
    stroke: "#181818",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16666667,8.33333333 L9.16666667,5.83333333 C9.16666667,4.45262146 10.2859548,3.33333333 11.6666667,3.33333333 L15,3.33333333 C16.3807119,3.33333333 17.5,4.45262146 17.5,5.83333333 L17.5,9.16666667 C17.5,10.5473785 16.3807119,11.6666667 15,11.6666667 L12.5,11.6666667",
    id: "Path",
    stroke: "#181818",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.08365,
    y1: 8.75,
    x2: 14.58365,
    y2: 6.25,
    id: "Path",
    stroke: "#181818",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.791667,8.87530833 C14.7914966,8.92127155 14.7541432,8.95841822 14.7081797,8.95833333 C14.6622163,8.95824816 14.6250006,8.92096353 14.6250006,8.875 C14.6250006,8.82903647 14.6622163,8.79175184 14.7081797,8.79166681 C14.7541432,8.79158178 14.7914966,8.82872845 14.791667,8.87469167 L14.791667,8.87530833",
    id: "Path",
    stroke: "#181818",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.875,6.12469167 C11.8751701,6.07872845 11.9125235,6.04158178 11.9584869,6.04166681 C12.0044504,6.04175184 12.0416664,6.07903647 12.0416664,6.125 C12.0416664,6.17096353 12.0044504,6.20824816 11.9584869,6.20833333 C11.9125235,6.20841822 11.8751701,6.17127155 11.875,6.12530833 L11.875,6.12469167",
    id: "Path",
    stroke: "#181818",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.86695833,12.6020833 L2.86695833,16.6666667 C2.86695833,17.126904 3.24005438,17.5 3.70029167,17.5 L8.75,17.5 C9.21023729,17.5 9.58333333,17.126904 9.58333333,16.6666667 L9.58333333,12.6669167",
    id: "Path",
    stroke: "#181818",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3543167,13.3333333 L6.7326,10.202875 C6.41965123,9.93236621 5.95564044,9.93236621 5.64269167,10.202875 L2.02098333,13.3333333",
    id: "Path",
    stroke: "#181818",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseExchangeSecond);
export default __webpack_public_path__ + "static/media/house-exchange-second.a3931994182108990d528d8e55c9a0a3.svg";
export { ForwardRef as ReactComponent };